import React from 'react'
import { Badge, TakeAways, LazyLoad, SeoHelmet } from '../../common/Functions'
import Roles from './roles'
import Ecosystem from './ecosystem'
import Branding from './branding'

function CaseEvict() {
  return (
   <div id="works">
    <SeoHelmet title="Case Evict" description="An online tenant-landlord case management system that allows handling and managing property cases for clients and law agencies." />
    <section className="banner caseevict px-0">
      <div className="max-w-screen-xl	mx-auto">
        <main className="mt-10">
          <div className="container mx-auto flex flex-wrap flex-col md:flex-row items-center justify-between py-10 px-0">
            <div className="lg:w-7/12 md:w-full inline-flex lg:justify-end ml-5 lg:ml-0 mt-10">
              <div className="content">
                <h1 className="text-left font-bold text-3xl text-white">
                  An online tenant-landlord case management system that allows handling and managing property cases for clients and law agencies.
                </h1>
                <p className="text-white mt-10">
                  Check how I help creates the tenant-landlord case management system.
                </p>
                <div className="roles mt-20">
                  <Badge title="UX/UI Design" />
                  <Badge title="Branding" />
                  <Badge title="Web Application" />
                </div>
              </div>
            </div>
            <div className="lg:w-5/12 md:w-full sm:order-first md:order-first lg:order-last flex items-center justify-center">
              <LazyLoad className="inline" src={require('../../common/images/caseevict/caseevict-white.svg')} alt="Case Evict Logo"/>
            </div>
          </div>
        </main>
      </div>
      </section>
      <Roles />
      <Ecosystem />
      <Branding />
      <TakeAways content="Getting freelance projects helps me to improve my decision-making skills in creating process flows. I see it as a challenge to learn new things and exploring other apps that I haven't used before. This kind of project gives me the space to progress my design thinking. Also, I started getting freelance projects during Pandemic. It is an accomplishment for me as it helps me to concentrate on improving my skills." />
   </div>
  )
}

export default CaseEvict
